import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { trackPromise } from 'react-promise-tracker';
import services from '../../../../../services';
import { useSnackBar } from '../../../../../hooks/snackBar';
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import {
    uploadImagemProduto,
    cadastrarProdutoSeller,
    detalheProdutoSeller,
    buscarDadosProdutoSeller,
    editarProdutoSeller,
    inativarProdutoSeller,
    ativarProdutoSeller,
    atualizarProdutoIntegracao
} from '../../../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService';
import EmptyImage from '../../../../../assets/img/emptyImage.PNG';

import './styles.scss';

const ProdutoForm = ({ id, subSellerPage }) => {
    const { addSnackBar } = useSnackBar();
    const { idEmpresa } = useParams();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [propertyBeingChanged, setPropertyBeingChanged] = useState(null);
    const [idProdutoSeller, setIdProdutoSeller] = useState(null);
    const [dadosEncontradosPorGtin, setBuscaPorGtin] = useState(null);
    const [voltou, setVoltou] = useState(false);
    const [mainState, setMainState] = useState("initial"); // initial, uploaded
    const [imageUploaded, setImageUploaded] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [file, setFile] = useState(null);
    const [atualizarProduto, setAtualizarProduto] = useState(false);
    const [camposNulosIntegracaoSimplus, setCamposNulosIntegracaoSimplus] = useState(null);
    const stateRef = useRef();
    stateRef.current = voltou;
    const [produtoSeller, setProdutoSeller] = useState({
        gtin: "",
        nomeProduto: "",
        gpc: "",
        categoria: "",
        ncm: "",
        descricaoNcm: "",
        descricaoProduto: "",
        produtoUrlImagem: "",
        paisRegistro: "",
        fabricante: "",
        distribuidores: "",
        marca: "",
        precoMedio: 0,
        validade: "",
        quantidadeUnidade: "",
        alturaUnidade: "",
        larguraUnidade: "",
        profundidadeUnidade: "",
        pesoBrutoUnidade: "",
        pesoLiquidoUnidade: "",
        volumeUnidade: "",
        gtinDun14Caixa: "",
        quantidadePorCaixa: "",
        alturaCaixa: "",
        larguraCaixa: "",
        profundidadeCaixa: "",
        volumeCaixa: "",
        pesoBrutoCaixa: "",
        pesoLiquidoCaixa: "",
        quantidadeDeCaixaPorPallet: "",
        alturaPallet: "",
        larguraPallet: "",
        profundidadePallet: "",
        pesoBrutoPallet: "",
        pesoLiquidoPallet: "",
        volumePallet: ""
    });

    const handleUploadClick = event => {
        console.log();
        var file = event.target.files[0];
        setFile(file);
        const reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {
            setSelectedFile([reader.result]);

        };

        console.log(url); // Would see a path?

        setMainState("uploaded");
        setSelectedFile(event.target.files[0]);
        setImageUploaded(1);
    };

    useEffect(() => {
        if (id != null) {
            setIdProdutoSeller(id);
            CarregarDetalhesProdutoSeller(id);
        }
        var elementAba = document.getElementById('aba-4');
        elementAba.classList.add("active");

        return () => {
            if (!stateRef.current) {
                elementAba.classList.remove("active");
            }
        }
    }, []);

    const voltar = () => {
        setVoltou(true);
        stateRef.current = true;
        subSellerPage(4);
    }

    const CarregarDetalhesProdutoSeller = (id) => {
        trackPromise(
            detalheProdutoSeller(id)
                .then(res => {
                    if (res.data) {
                        setProdutoSeller(res.data);
                    } else {
                        if (id) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do produto', info: 'warning', open: true });
                        }
                    }
                    setBuscaPorGtin(false);

                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do produto', info: 'error', open: true });
                    setBuscaPorGtin(false);
                })
        )
    }

    const atualizarProdutoSimplus = () => {
        trackPromise(
            atualizarProdutoIntegracao(produtoSeller.gtin)
                .then(res => {
                    if (res.data) {
                        setBuscaPorGtin(true);
                        setAtualizarProduto(true);
                        validarCampoNaoSeAplica(res.data);
                        setCamposNulosIntegracaoSimplus(res.data);
                        atribuirValoresDaAtualizacao(res.data);
                    } else {
                        setBuscaPorGtin(false);
                        addSnackBar({ message: 'Nenhum produto encontrado com o Gtin informado.', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do produto por Gtin', info: 'error', open: true });
                    setBuscaPorGtin(false);
                })
        )
    }

    const atribuirValoresDaAtualizacao = (data) => {
        setProdutoSeller((prevent) => ({
            gtin: data?.gtin ?? prevent.gtin,
            nomeProduto: data?.nomeProduto != '' ? data?.nomeProduto : prevent.nomeProduto,
            gpc: data?.gpc ?? prevent.gpc,
            categoria: data?.categoria ?? prevent.categoria,
            ncm: data?.ncm ?? prevent.ncm,
            descricaoProduto: data?.descricaoProduto ?? prevent.descricaoProduto,
            produtoUrlImagem: data?.produtoUrlImagem ?? prevent.produtoUrlImagem,
            dataValidade: data?.dataValidade ?? prevent.dataValidade,
            paisRegistro: data?.paisRegistro ?? prevent.paisRegistro,
            fabricante: data?.fabricante ?? prevent.fabricante,
            distribuidores: data?.distribuidores ?? prevent.distribuidores,
            marca: data?.marca ?? prevent.marca,
            precoMedio: data?.precoMedio ?? prevent.precoMedio,
            descricaoNcm: data?.descricaoNcm ?? prevent.descricaoNcm,
            validade: data?.validade ?? prevent.validade,
            quantidadeUnidade: data?.quantidadeUnidade ?? prevent.quantidadeUnidade,
            alturaUnidade: data?.alturaUnidade ?? prevent.alturaUnidade,
            larguraUnidade: data?.larguraUnidade ?? prevent.larguraUnidade,
            profundidadeUnidade: data?.profundidadeUnidade ?? prevent.profundidadeUnidade,
            pesoBrutoUnidade: data?.pesoBrutoUnidade ?? prevent.pesoBrutoUnidade,
            pesoLiquidoUnidade: data?.pesoLiquidoUnidade ?? prevent.pesoLiquidoUnidade,
            volumeUnidade: data?.volumeUnidade ?? prevent.volumeUnidade,
            gtinDun14Caixa: data?.gtinDun14Caixa ?? prevent.gtinDun14Caixa,
            quantidadePorCaixa: data?.quantidadePorCaixa ?? prevent.quantidadePorCaixa,
            alturaCaixa: data?.alturaCaixa ?? prevent.alturaCaixa,
            larguraCaixa: data?.larguraCaixa ?? prevent.larguraCaixa,
            profundidadeCaixa: data?.profundidadeCaixa ?? prevent.profundidadeCaixa,
            volumeCaixa: data?.volumeCaixa ?? prevent.volumeCaixa,
            pesoBrutoCaixa: data?.pesoBrutoCaixa ?? prevent.pesoBrutoCaixa,
            pesoLiquidoCaixa: data?.pesoLiquidoCaixa ?? prevent.pesoLiquidoCaixa,
            quantidadeDeCaixaPorPallet: data?.quantidadeDeCaixaPorPallet ?? prevent.quantidadeDeCaixaPorPallet,
            alturaPallet: data?.alturaPallet ?? prevent.alturaPallet,
            larguraPallet: data?.larguraPallet ?? prevent.larguraPallet,
            profundidadePallet: data?.profundidadePallet ?? prevent.profundidadePallet,
            pesoBrutoPallet: data?.pesoBrutoPallet ?? prevent.pesoBrutoPallet,
            pesoLiquidoPallet: data?.pesoLiquidoPallet ?? prevent.pesoLiquidoPallet,
            volumePallet: data?.volumePallet ?? prevent.volumePallet
        }));
    }

    const uploadImagem = () => {
        if (file != null && file != undefined) {
            trackPromise(
                uploadImagemProduto(file)
                    .then(res => {
                        if (res.data) {
                            changesProduto(res.data, "produtoUrlImagem");
                            submitProdutoSeller(res.data);
                        } else {
                            addSnackBar({ message: 'Não foi possível extrair a base com produtos', info: 'warning', open: true });
                        }
                    })
            ).catch(error => {
                addSnackBar({ message: 'Erro ao fazer upload da imagem do produto', info: 'error', open: true });
            })
        }
        else {
            submitProdutoSeller();
        }

    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!(produtoSeller.gtin != null && produtoSeller.gtin != "" && produtoSeller.gtin != undefined)) isInvalidForm = true;
        if (!(produtoSeller.nomeProduto != null && produtoSeller.nomeProduto != "" && produtoSeller.nomeProduto != undefined)) isInvalidForm = true;
        if (!(produtoSeller.gpc != null && produtoSeller.gpc != "" && produtoSeller.gpc != undefined)) isInvalidForm = true;
        if (!(produtoSeller.categoria != null && produtoSeller.categoria != "" && produtoSeller.categoria != undefined)) isInvalidForm = true;
        if (!(produtoSeller.ncm != null && produtoSeller.ncm != "" && produtoSeller.ncm != undefined)) isInvalidForm = true;
        if (!(produtoSeller.descricaoProduto != null && produtoSeller.descricaoProduto != "" && produtoSeller.descricaoProduto != undefined)) isInvalidForm = true;
        if (!(produtoSeller.paisRegistro != null && produtoSeller.paisRegistro != "" && produtoSeller.paisRegistro != undefined)) isInvalidForm = true;
        if (!(produtoSeller.fabricante != null && produtoSeller.fabricante != "" && produtoSeller.fabricante != undefined)) isInvalidForm = true;
        if (!(produtoSeller.distribuidores != null && produtoSeller.distribuidores != "" && produtoSeller.distribuidores != undefined)) isInvalidForm = true;
        if (!(produtoSeller.marca != null && produtoSeller.marca != "" && produtoSeller.marca != undefined)) isInvalidForm = true;
        if (!(produtoSeller.precoMedio != null && produtoSeller.precoMedio != undefined)) isInvalidForm = true;
        if (!(produtoSeller.alturaCaixa != null && produtoSeller.alturaCaixa != "" && produtoSeller.alturaCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.alturaPallet != null != null && produtoSeller.alturaPallet != "" && produtoSeller.alturaPallet != undefined)) isInvalidForm = true;
        if (!(produtoSeller.alturaUnidade && produtoSeller.alturaUnidade != "" && produtoSeller.alturaUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.gtinDun14Caixa != null && produtoSeller.gtinDun14Caixa != "" && produtoSeller.gtinDun14Caixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.descricaoNcm != null && produtoSeller.descricaoNcm != "" && produtoSeller.descricaoNcm != undefined)) isInvalidForm = true;
        if (!(produtoSeller.volumeUnidade != null && produtoSeller.volumeUnidade != "" && produtoSeller.volumeUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.larguraCaixa != null && produtoSeller.larguraCaixa != "" && produtoSeller.larguraCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.larguraPallet != null && produtoSeller.larguraPallet != "" && produtoSeller.larguraPallet != undefined)) isInvalidForm = true;
        if (!(produtoSeller.larguraUnidade != null && produtoSeller.larguraUnidade != "" && produtoSeller.larguraUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.pesoBrutoCaixa != null && produtoSeller.pesoBrutoCaixa != "" && produtoSeller.pesoBrutoCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.pesoBrutoPallet != null && produtoSeller.pesoBrutoPallet != "" && produtoSeller.pesoBrutoPallet != undefined)) isInvalidForm = true;
        if (!(produtoSeller.pesoBrutoUnidade != null && produtoSeller.pesoBrutoUnidade != "" && produtoSeller.pesoBrutoUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.pesoLiquidoCaixa != null && produtoSeller.pesoLiquidoCaixa != "" && produtoSeller.pesoLiquidoCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.pesoLiquidoPallet != null && produtoSeller.pesoLiquidoPallet != "" && produtoSeller.pesoLiquidoPallet != undefined)) isInvalidForm = true;
        if (!(produtoSeller.pesoLiquidoUnidade != null && produtoSeller.pesoLiquidoUnidade != "" && produtoSeller.pesoLiquidoUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.profundidadeCaixa != null && produtoSeller.profundidadeCaixa != "" && produtoSeller.profundidadeCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.profundidadePallet != null && produtoSeller.profundidadePallet != "" && produtoSeller.profundidadePallet != undefined)) isInvalidForm = true;
        if (!(produtoSeller.profundidadeUnidade != null && produtoSeller.profundidadeUnidade != "" && produtoSeller.profundidadeUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.quantidadeDeCaixaPorPallet != null && produtoSeller.quantidadeDeCaixaPorPallet != "" && produtoSeller.quantidadeDeCaixaPorPallet != undefined)) isInvalidForm = true;
        if (!(produtoSeller.quantidadePorCaixa != null && produtoSeller.quantidadePorCaixa != "" && produtoSeller.quantidadePorCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.quantidadeUnidade != null && produtoSeller.quantidadeUnidade != "" && produtoSeller.quantidadeUnidade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.validade != null && produtoSeller.validade != "" && produtoSeller.validade != undefined)) isInvalidForm = true;
        if (!(produtoSeller.volumeCaixa != null && produtoSeller.volumeCaixa != "" && produtoSeller.volumeCaixa != undefined)) isInvalidForm = true;
        if (!(produtoSeller.volumePallet != null && produtoSeller.volumePallet != "" && produtoSeller.volumePallet != undefined)) isInvalidForm = true;

        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }


    const inativarProduto = () => {
        if (id != undefined) {
            trackPromise(
                inativarProdutoSeller(id)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'produto inativado com sucesso', info: 'success', open: true });
                            voltar(3);
                        } else {
                            addSnackBar({ message: 'Não foi possível inativar produto', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar produto', info: 'error', open: true });
                    })
            )
        }
    }

    const ativarProduto = () => {
        if (id != undefined) {
            trackPromise(
                ativarProdutoSeller(id)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'produto ativado com sucesso', info: 'success', open: true });
                            voltar(3);
                        } else {
                            res.errors.forEach(element => {
                                addSnackBar({
                                    message: element.mensagem,
                                    info: 'warning',
                                    open: true
                                })
                            })
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar produto', info: 'error', open: true });
                    })
            )
        }
    }

    const submitProdutoSeller = (urlImg = "") => {
        if (!validarForm()) {

            if (urlImg != "") {
                produtoSeller.produtoUrlImagem = urlImg;
            }
            produtoSeller.precoMedio = services.mask.unMask(produtoSeller.precoMedio.toString());
            if (id == null || id == undefined) {
                trackPromise(
                    cadastrarProdutoSeller(produtoSeller, idEmpresa)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                voltar(3);
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({
                                        message: element.menssagem,
                                        info: 'warning',
                                        open: true
                                    })
                                })
                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar produto', info: 'error', open: true });
                        })
                )
            }
            else {
                produtoSeller.id = id;
                trackPromise(
                    editarProdutoSeller(produtoSeller)
                        .then(res => {
                            if (res.fail == null) {
                                addSnackBar({ message: 'Seller atualizado com sucesso', info: 'success', open: true });
                                voltar(3)
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({
                                        message: element.menssagem,
                                        info: 'warning',
                                        open: true
                                    })
                                })
                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao editar produto', info: 'error', open: true });
                        })
                )
            }

        }
    }

    /*   useEffect(() => {
          CarregarDetalhesProdutoSeller();
      }, []);
    */

    const showEmptyImage = () => {
        if (imageUploaded == 0 && produtoSeller.produtoUrlImagem == "") {
            return (<div className="d-flex justify-content-center empty-image">
                <img
                    className="image"
                    src={EmptyImage}
                />
            </div>);
        }
    }

    const changesProduto = (value, propertie) => {
        setPropertyBeingChanged(propertie);
        setProdutoSeller((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const validarCampoNaoSeAplica = (data) => {
        if (data.distribuidores = 'Não se Aplica!') data.distribuidores = null;
        if (data.nomeProduto == 'Não se Aplica!') data.nomeProduto = null;
        if (data.gpc == 'Não se Aplica!') data.gpc = null;
        if (data.categoria == 'Não se Aplica!') data.categoria = null;
        if (data.ncm == 'Não se Aplica!') data.ncm = null;
        if (data.descricaoProduto == 'Não se Aplica!') data.descricaoProduto = null;
        if (data.paisRegistro == 'Não se Aplica!') data.paisRegistro = null;
        if (data.fabricante == 'Não se Aplica!') data.fabricante = null;
        if (data.distribuidores == 'Não se Aplica!') data.distribuidores = null;
        if (data.marca == 'Não se Aplica!') data.marca = null;
        if (data.descricaoNcm == 'Não se Aplica!') data.descricaoNcm = null;
        if (data.validade == 'Não se Aplica!') data.validade = null;
        if (data.quantidadeUnidade == 'Não se Aplica!') data.quantidadeUnidade = null;
        if (data.alturaUnidade == 'Não se Aplica!') data.alturaUnidade = null;
        if (data.larguraUnidade == 'Não se Aplica!') data.larguraUnidade = null;
        if (data.profundidadeUnidade == 'Não se Aplica!') data.profundidadeUnidade = null;
        if (data.pesoBrutoUnidade == 'Não se Aplica!') data.pesoBrutoUnidade = null;
        if (data.pesoLiquidoUnidade == 'Não se Aplica!') data.pesoLiquidoUnidade = null;
        if (data.volumeUnidade == 'Não se Aplica!') data.volumeUnidade = null;
        if (data.gtinDun14Caixa == 'Não se Aplica!') data.gtinDun14Caixa = null;
        if (data.quantidadePorCaixa == 'Não se Aplica!') data.quantidadePorCaixa = null;
        if (data.alturaCaixa == 'Não se Aplica!') data.alturaCaixa = null;
        if (data.larguraCaixa == 'Não se Aplica!') data.larguraCaixa = null;
        if (data.profundidadeCaixa == 'Não se Aplica!') data.profundidadeCaixa = null;
        if (data.volumeCaixa == 'Não se Aplica!') data.volumeCaixa = null;
        if (data.pesoBrutoCaixa == 'Não se Aplica!') data.pesoBrutoCaixa = null;
        if (data.pesoLiquidoCaixa == 'Não se Aplica!') data.pesoLiquidoCaixa = null;
        if (data.quantidadeDeCaixaPorPallet == 'Não se Aplica!') data.quantidadeDeCaixaPorPallet = null;
        if (data.alturaPallet == 'Não se Aplica!') data.alturaPallet = null;
        if (data.larguraPallet == 'Não se Aplica!') data.larguraPallet = null;
        if (data.profundidadePallet == 'Não se Aplica!') data.profundidadePallet = null;
        if (data.pesoBrutoPallet == 'Não se Aplica!') data.pesoBrutoPallet = null;
        if (data.pesoLiquidoPallet == 'Não se Aplica!') data.pesoLiquidoPallet = null;
        if (data.volumePallet == 'Não se Aplica!') data.volumePallet = null;

    }

    const consultarIntegracaoProdutos = (value) => {
        trackPromise(
            buscarDadosProdutoSeller(value, idEmpresa)
                .then(res => {
                    if (res.data) {
                        validarCampoNaoSeAplica(res.data);
                        setBuscaPorGtin(true);
                        setProdutoSeller(res.data);
                    } else {
                        setProdutoSeller({
                            gtin: value,
                            nomeProduto: "",
                            gpc: "",
                            categoria: "",
                            ncm: "",
                            descricaoProduto: "",
                            produtoUrlImagem: "",
                            paisRegistro: "",
                            fabricante: "",
                            distribuidores: "",
                            marca: "",
                            precoMedio: 0,
                            descricaoNcm: "",
                            validade: "",
                            quantidadeUnidade: "",
                            alturaUnidade: "",
                            larguraUnidade: "",
                            profundidadeUnidade: "",
                            pesoBrutoUnidade: "",
                            pesoLiquidoUnidade: "",
                            volumeUnidade: "",
                            gtinDun14Caixa: "",
                            quantidadePorCaixa: "",
                            alturaCaixa: "",
                            larguraCaixa: "",
                            profundidadeCaixa: "",
                            volumeCaixa: "",
                            pesoBrutoCaixa: "",
                            pesoLiquidoCaixa: "",
                            quantidadeDeCaixaPorPallet: "",
                            alturaPallet: "",
                            larguraPallet: "",
                            profundidadePallet: "",
                            pesoBrutoPallet: "",
                            pesoLiquidoPallet: "",
                            volumePallet: ""
                        });
                        setBuscaPorGtin(false);
                        addSnackBar({ message: 'Nenhum produto encontrado com o Gtin informado.', info: 'warning', open: true });
                    }
                }).catch(error => {
                    setProdutoSeller({
                        gtin: "",
                        nomeProduto: "",
                        gpc: "",
                        categoria: "",
                        ncm: "",
                        descricaoProduto: "",
                        produtoUrlImagem: "",
                        paisRegistro: "",
                        fabricante: "",
                        distribuidores: "",
                        marca: "",
                        precoMedio: 0,
                        descricaoNcm: "",
                        validade: "",
                        quantidadeUnidade: "",
                        alturaUnidade: "",
                        larguraUnidade: "",
                        profundidadeUnidade: "",
                        pesoBrutoUnidade: "",
                        pesoLiquidoUnidade: "",
                        volumeUnidade: "",
                        gtinDun14Caixa: "",
                        quantidadePorCaixa: "",
                        alturaCaixa: "",
                        larguraCaixa: "",
                        profundidadeCaixa: "",
                        volumeCaixa: "",
                        pesoBrutoCaixa: "",
                        pesoLiquidoCaixa: "",
                        quantidadeDeCaixaPorPallet: "",
                        alturaPallet: "",
                        larguraPallet: "",
                        profundidadePallet: "",
                        pesoBrutoPallet: "",
                        pesoLiquidoPallet: "",
                        volumePallet: ""
                    });
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do produto por Gtin', info: 'error', open: true });
                    setBuscaPorGtin(false);
                })
        )
    }

    const buscarDadosPorGtin = (event) => {
        let value = event.target.value;
        //alert(value);
        //alert(idEmpresa);
        if (event.code === "Enter" || event.code === "NumpadEnter") {
            consultarIntegracaoProdutos(value);
        }
    }

    const disableField = (value, propertie) => {
        if (idProdutoSeller == null) {
            return (value != null && value != '' && propertie != propertyBeingChanged && dadosEncontradosPorGtin);
        }

        else if (idProdutoSeller != null && atualizarProduto == false) {
            return true;
        } else if (camposNulosIntegracaoSimplus != null) {
            return camposNulosIntegracaoSimplus[propertie] == null ? false : camposNulosIntegracaoSimplus[propertie] == '' ? false : true;
        }

    };

    const styles = theme => ({
        input: {
            color: 'red'
        }
    });

    return (
        <div className="ml-1 mt20">

            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Dados do Produto</strong></div></div>
            <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <FormControl>
                                <TextField
                                    required
                                    label="GTIN/EAN(Código de Barras)"
                                    inputProps={{ maxLength: 14, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={id != null}
                                    onKeyPress={event => buscarDadosPorGtin(event)}
                                    onChange={event => changesProduto(event.target.value, 'gtin')}
                                    value={produtoSeller?.gtin || ''}
                                    helperText={isFormInvalid && !produtoSeller?.gtin && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.gtin ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <CardActionArea /* onClick={this.imageResetHandler} */>
                                <img
                                    width="100%"
                                    /*  className={classes.media} */
                                    src={selectedFile ?? produtoSeller?.produtoUrlImagem}
                                />
                            </CardActionArea>
                        </div>
                    </div>

                    {(idProdutoSeller != null && atualizarProduto || idProdutoSeller == null) && (<div className="row">

                        <div className="col-sm-12 col-md-12 col-lg-12">

                            <CardContent>
                                {showEmptyImage()}
                                <Grid container justify="center" alignItems="center">
                                    <input
                                        accept="image/*"
                                        className="d-none"
                                        id="contained-button-file"
                                        multiple
                                        type="file"
                                        onChange={(event) => handleUploadClick(event)}
                                    />

                                </Grid>
                                <div className="d-flex justify-content-center" disabled={disableField(produtoSeller?.produtoUrlImagem)} >
                                    <label htmlFor="contained-button-file">
                                        <Fab component="span">
                                            Incluir Foto
                                        </Fab>
                                    </label>
                                </div>
                            </CardContent>
                        </div>

                    </div>)
                    }
                </div>

                <div className="col-sm-9 col-md-9 col-lg-9">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <FormControl>
                                <TextField
                                    required
                                    label="Descrição Curta"
                                    inputProps={{ maxLength: 250, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.nomeProduto, 'nomeProduto')}
                                    onChange={event => changesProduto(event.target.value, 'nomeProduto')}
                                    value={produtoSeller?.nomeProduto || ''}
                                    helperText={isFormInvalid && !produtoSeller?.nomeProduto && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.nomeProduto ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <FormControl>
                                <TextField
                                    required
                                    label="Descrição Longa"
                                    inputProps={{ maxLength: 250, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.descricaoProduto, 'descricaoProduto')}
                                    onChange={event => changesProduto(event.target.value, 'descricaoProduto')}
                                    value={produtoSeller?.descricaoProduto || ''}
                                    helperText={isFormInvalid && !produtoSeller?.descricaoProduto && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.descricaoProduto ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                            <FormControl>
                                <TextField
                                    required
                                    label="GPC(Classificação Global de Produtos) "
                                    inputProps={{ maxLength: 150, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.gpc, 'gpc')}
                                    onChange={event => changesProduto(event.target.value, 'gpc')}
                                    value={produtoSeller?.gpc || ''}
                                    helperText={isFormInvalid && !produtoSeller?.gpc && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.gpc ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                            <FormControl>
                                <TextField
                                    required
                                    label="Categoria"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.categoria, 'categoria')}
                                    onChange={event => changesProduto(event.target.value, 'categoria')}
                                    value={produtoSeller?.categoria || ''}
                                    helperText={isFormInvalid && !produtoSeller?.categoria && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.categoria ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                            <FormControl>
                                <TextField
                                    required
                                    label="NCM (Nomenclatura Comum do Mercosul)"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.ncm, 'ncm')}
                                    onChange={event => changesProduto(event.target.value, 'ncm')}
                                    value={produtoSeller?.ncm || ''}
                                    helperText={isFormInvalid && !produtoSeller?.ncm && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.ncm ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <FormControl>
                                <TextField
                                    required
                                    label="Descrição NCM"
                                    inputProps={{ maxLength: 550, style: { color: 'black' } }}
                                    multiline={true}
                                    type="text"
                                    size="medium"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.descricaoNcm, 'descricaoNcm')}
                                    onChange={event => changesProduto(event.target.value, 'descricaoNcm')}
                                    value={produtoSeller?.descricaoNcm || ''}
                                    helperText={isFormInvalid && !produtoSeller?.descricaoNcm && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.descricaoNcm ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <TextField
                            required
                            label="País de Registro"
                            inputProps={{ maxLength: 50, style: { color: 'black' } }}
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            disabled={disableField(produtoSeller?.paisRegistro, 'paisRegistro')}
                            onChange={event => changesProduto(event.target.value, 'paisRegistro')}
                            value={produtoSeller?.paisRegistro || ''}
                            helperText={isFormInvalid && !produtoSeller?.paisRegistro && 'Campo obrigatório'}
                            error={isFormInvalid && !produtoSeller?.paisRegistro ? true : false}
                        />
                    </FormControl>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <TextField
                            required
                            label="Fabricante"
                            inputProps={{ maxLength: 50, style: { color: 'black' } }}
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            disabled={disableField(produtoSeller?.fabricante, 'fabricante')}
                            onChange={event => changesProduto(event.target.value, 'fabricante')}
                            value={produtoSeller?.fabricante || ''}
                            helperText={isFormInvalid && !produtoSeller?.fabricante && 'Campo obrigatório'}
                            error={isFormInvalid && !produtoSeller?.fabricante ? true : false}
                        />
                    </FormControl>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <TextField
                            required
                            label="Distribuidores "
                            inputProps={{ maxLength: 50, style: { color: 'black' } }}
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            disabled={disableField(produtoSeller?.distribuidores, 'distribuidores')}
                            onChange={event => changesProduto(event.target.value, 'distribuidores')}
                            value={produtoSeller?.distribuidores || ''}
                            helperText={isFormInvalid && !produtoSeller?.distribuidores && 'Campo obrigatório'}
                            error={isFormInvalid && !produtoSeller?.distribuidores ? true : false}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <TextField
                            required
                            label="Marca"
                            inputProps={{ maxLength: 50, style: { color: 'black' } }}
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            disabled={disableField(produtoSeller?.marca, 'marca')}
                            onChange={event => changesProduto(event.target.value, 'marca')}
                            value={produtoSeller?.marca || ''}
                            helperText={isFormInvalid && !produtoSeller?.marca && 'Campo obrigatório'}
                            error={isFormInvalid && !produtoSeller?.marca ? true : false}
                        />
                    </FormControl>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <TextField
                            required
                            label="Validade"
                            type="text"
                            size="small"
                            inputProps={{ maxLength: 100, style: { color: 'black' } }}
                            id="outlined-basic"
                            variant="outlined"
                            disabled={disableField(produtoSeller?.validade, 'validade')}
                            onChange={event => changesProduto(event.target.value, 'validade')}
                            value={produtoSeller?.validade}
                            helperText={isFormInvalid && !produtoSeller?.validade && 'Campo obrigatório'}
                            error={isFormInvalid && !produtoSeller?.validade ? true : false}
                        />
                    </FormControl>
                </div>
            </div>

            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Dados Logísticos</strong></div></div>

            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Unidade</strong></div></div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Quantidade"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.quantidadeUnidade, 'quantidadeUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'quantidadeUnidade')}
                                    value={produtoSeller?.quantidadeUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.quantidadeUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.quantidadeUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Altura"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.alturaUnidade, 'alturaUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'alturaUnidade')}
                                    value={produtoSeller?.alturaUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.alturaUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.alturaUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Largura"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.larguraUnidade, 'larguraUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'larguraUnidade')}
                                    value={produtoSeller?.larguraUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.larguraUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.larguraUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Profundidade"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.profundidadeUnidade, 'profundidadeUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'profundidadeUnidade')}
                                    value={produtoSeller?.profundidadeUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.profundidadeUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.profundidadeUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Peso Bruto"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.pesoBrutoUnidade, 'pesoBrutoUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'pesoBrutoUnidade')}
                                    value={produtoSeller?.pesoBrutoUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.pesoBrutoUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.pesoBrutoUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Peso Líquido"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.pesoLiquidoUnidade, 'pesoLiquidoUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'pesoLiquidoUnidade')}
                                    value={produtoSeller?.pesoLiquidoUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.pesoLiquidoUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.pesoLiquidoUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Volume"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.volumeUnidade, 'volumeUnidade')}
                                    onChange={event => changesProduto(event.target.value, 'volumeUnidade')}
                                    value={produtoSeller?.volumeUnidade || ''}
                                    helperText={isFormInvalid && !produtoSeller?.volumeUnidade && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.volumeUnidade ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                        </div>
                    </div>
                </div>
            </div>

            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Caixa</strong></div></div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="GTIN/DUN-14"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.gtinDun14Caixa, 'gtinDun14Caixa')}
                                    onChange={event => changesProduto(event.target.value, 'gtinDun14Caixa')}
                                    value={produtoSeller?.gtinDun14Caixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.gtinDun14Caixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.gtinDun14Caixa ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Quantidade por Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.quantidadePorCaixa, 'quantidadePorCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'quantidadePorCaixa')}
                                    value={produtoSeller?.quantidadePorCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.quantidadePorCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.quantidadePorCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Altura da Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.alturaCaixa, 'alturaCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'alturaCaixa')}
                                    value={produtoSeller?.alturaCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.alturaCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.alturaCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Largura da Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.larguraCaixa, 'larguraCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'larguraCaixa')}
                                    value={produtoSeller?.larguraCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.larguraCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.larguraCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Profundidade da Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.profundidadeCaixa, 'profundidadeCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'profundidadeCaixa')}
                                    value={produtoSeller?.profundidadeCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.profundidadeCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.profundidadeCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Volume da Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.volumeCaixa, 'volumeCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'volumeCaixa')}
                                    value={produtoSeller?.volumeCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.volumeCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.volumeCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Peso Bruto por Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.pesoBrutoCaixa, 'pesoBrutoCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'pesoBrutoCaixa')}
                                    value={produtoSeller?.pesoBrutoCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.pesoBrutoCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.pesoBrutoCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Peso Líquido por Caixa"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.pesoLiquidoCaixa, 'pesoLiquidoCaixa')}
                                    onChange={event => changesProduto(event.target.value, 'pesoLiquidoCaixa')}
                                    value={produtoSeller?.pesoLiquidoCaixa || ''}
                                    helperText={isFormInvalid && !produtoSeller?.pesoLiquidoCaixa && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.pesoLiquidoCaixa ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Paletização</strong></div></div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Qtde. de caixas por pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.quantidadeDeCaixaPorPallet, 'quantidadeDeCaixaPorPallet')}
                                    onChange={event => changesProduto(event.target.value, 'quantidadeDeCaixaPorPallet')}
                                    value={produtoSeller?.quantidadeDeCaixaPorPallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.quantidadeDeCaixaPorPallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.quantidadeDeCaixaPorPallet ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Altura do pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.alturaPallet, 'alturaPallet')}
                                    onChange={event => changesProduto(event.target.value, 'alturaPallet')}
                                    value={produtoSeller?.alturaPallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.alturaPallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.alturaPallet ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Largura do pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.larguraPallet, 'larguraPallet')}
                                    onChange={event => changesProduto(event.target.value, 'larguraPallet')}
                                    value={produtoSeller?.larguraPallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.larguraPallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.larguraPallet ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Profundidade do pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.profundidadePallet, 'profundidadePallet')}
                                    onChange={event => changesProduto(event.target.value, 'profundidadePallet')}
                                    value={produtoSeller?.profundidadePallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.profundidadePallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.profundidadePallet ? true : false}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Peso bruto do pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.pesoBrutoPallet, 'pesoBrutoPallet')}
                                    onChange={event => changesProduto(event.target.value, 'pesoBrutoPallet')}
                                    value={produtoSeller?.pesoBrutoPallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.pesoBrutoPallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.pesoBrutoPallet ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Peso liquido do pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.pesoLiquidoPallet, 'pesoLiquidoPallet')}
                                    onChange={event => changesProduto(event.target.value, 'pesoLiquidoPallet')}
                                    value={produtoSeller?.pesoLiquidoPallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.pesoLiquidoPallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.pesoLiquidoPallet ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <FormControl>
                                <TextField
                                    required
                                    label="Volume do pallet"
                                    inputProps={{ maxLength: 50, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disableField(produtoSeller?.volumePallet, 'volumePallet')}
                                    onChange={event => changesProduto(event.target.value, 'volumePallet')}
                                    value={produtoSeller?.volumePallet || ''}
                                    helperText={isFormInvalid && !produtoSeller?.volumePallet && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.volumePallet ? true : false}
                                />
                            </FormControl>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="col-sm-12 col-md-12 col-lg-12 mt-5 flex flex-end buttons">
                <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={uploadImagem}>SALVAR</button>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(4)}>CANCELAR</button>
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarProduto}>INATIVAR</button>
            </div> */}

            {(idProdutoSeller && atualizarProduto) &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={uploadImagem}>SALVAR</button>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(4)}>CANCELAR</button>
                        {produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarProduto} >INATIVAR</button>}
                        {!produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarProduto}  >ATIVAR</button>}

                    </div>


                </div>}

            {(idProdutoSeller && !atualizarProduto) &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={atualizarProdutoSimplus}>ATUALIZAR CADASTRO</button>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(4)}>CANCELAR</button>
                        {produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarProduto} >INATIVAR</button>}
                        {!produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarProduto}  >ATIVAR</button>}

                    </div>


                </div>}

            {idProdutoSeller == null &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(4)}>CANCELAR</button>
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={uploadImagem}>SALVAR</button>
                    </div>

                </div>}
        </div>
    )
}

export default ProdutoForm;